import { RSFundPageModel } from '../../api.types';

export interface CollateralStressTestPosition {
  gm_name_long: string;
  isin: string | null;
  market_price: number;
  base_currency: string;
  mr_position: number;
  [key: string]: unknown;
}

export type CollateralStressTestEntry = [string, number[]];

export interface CollateralStressTestPayload {
  positions?: CollateralStressTestPosition[] | string;
  risk_sector_stress_tests: CollateralStressTestEntry[];
  historical_stress_tests: CollateralStressTestEntry[];
  relative_stress_tests?: CollateralStressTestEntry[];
  risk_sector_order?: string[];
  historical_order?: string[];
  position_level_breakdown?: Record<string, unknown[]>;
  nav: number;
  stressed_pnl: number;
  haircut_limit: number;
  status: string;
  ex_ante_value?: number;
  ex_post_value?: number;
  unrealised_pl?: number;
}

/** Inner `data` on `GET collateral-stress-test-page/<fund_name>`. */
export interface CollateralStressTestPageData {
  selected_position_date?: string;
  Portfolio?: CollateralStressTestPayload;
  [portfolioName: string]: CollateralStressTestPayload | string | undefined;
}

/** API response for collateral stress test — `RSFundPageModel` from `PageModel.to_dict()`. */
export type CollateralStressTestPageModel =
  RSFundPageModel<CollateralStressTestPageData>;

export function resolveCollateralPortfolioPayload(
  pageModel: CollateralStressTestPageModel,
): CollateralStressTestPayload | null {
  const { data } = pageModel;

  if (!data || typeof data !== 'object' || Array.isArray(data)) {
    return null;
  }

  if (data.Portfolio && typeof data.Portfolio === 'object') {
    return data.Portfolio;
  }

  const portfolioPayload = Object.entries(data).find(
    ([key, value]) =>
      key !== 'selected_position_date' &&
      value &&
      typeof value === 'object' &&
      !Array.isArray(value) &&
      'nav' in value,
  )?.[1];

  return (portfolioPayload as CollateralStressTestPayload) ?? null;
}
